// Pixel art sprites defined as arrays of colors
// Each sprite has width, height, and a flat array of pixel colors
// 'transparent' or null = no pixel

const T = 'transparent'

// Skin tones and colors
const SKIN = '#f5c5a3'
const SKIN_SHADE = '#d4a574'
const HAIR = '#5a3825'
const HAIR_DARK = '#3d261a'
const EYE = '#2a2a2a'
const SHIRT = '#3a7ecf'
const SHIRT_SHADE = '#2a5a9f'
const SHIRT_LIGHT = '#5a9eef'
const PANTS = '#4a4a6a'
const PANTS_SHADE = '#3a3a5a'
const BOOT = '#3a2a1a'
const BOOT_SHADE = '#2a1a0a'
const BELT = '#8a6a3a'

// Player sprites for each direction (16x16)
// Facing DOWN (toward camera) - front view with more detail
export const PLAYER_DOWN = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,HAIR_DARK,HAIR,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,HAIR,HAIR_DARK,T,T,T,
    T,T,T,HAIR_DARK,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,HAIR_DARK,T,T,T,
    T,T,T,T,SKIN,EYE,'#fff',SKIN,SKIN,'#fff',EYE,SKIN,T,T,T,T,
    T,T,T,T,SKIN,SKIN,SKIN,SKIN_SHADE,SKIN_SHADE,SKIN,SKIN,SKIN,T,T,T,T,
    T,T,T,T,T,SKIN,SKIN,'#c66','#c66',SKIN,SKIN,T,T,T,T,T,
    T,T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,
    T,T,T,T,SHIRT_LIGHT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_LIGHT,T,T,T,T,
    T,T,T,SKIN,SHIRT,SHIRT,SHIRT,BELT,BELT,SHIRT,SHIRT,SHIRT,SKIN,T,T,T,
    T,T,T,SKIN,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,
    T,T,T,T,SHIRT_SHADE,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,SHIRT_SHADE,T,T,T,T,
    T,T,T,T,T,PANTS,PANTS,PANTS,PANTS,PANTS,PANTS,T,T,T,T,T,
    T,T,T,T,T,PANTS,PANTS_SHADE,T,T,PANTS_SHADE,PANTS,T,T,T,T,T,
    T,T,T,T,T,BOOT,BOOT,T,T,BOOT,BOOT,T,T,T,T,T,
    T,T,T,T,T,BOOT_SHADE,BOOT_SHADE,T,T,BOOT_SHADE,BOOT_SHADE,T,T,T,T,T,
  ]
}

// Facing UP (away from camera) - back view
export const PLAYER_UP = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,
    T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,
    T,T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,
    T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,
    T,T,T,SKIN,SHIRT_SHADE,SHIRT,SHIRT,BELT,BELT,SHIRT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,
    T,T,T,SKIN,SHIRT_SHADE,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,SHIRT_SHADE,SKIN,T,T,T,
    T,T,T,T,SHIRT_SHADE,SHIRT_SHADE,SHIRT_SHADE,SHIRT,SHIRT,SHIRT_SHADE,SHIRT_SHADE,SHIRT_SHADE,T,T,T,T,
    T,T,T,T,T,PANTS_SHADE,PANTS,PANTS,PANTS,PANTS,PANTS_SHADE,T,T,T,T,T,
    T,T,T,T,T,PANTS_SHADE,PANTS_SHADE,T,T,PANTS_SHADE,PANTS_SHADE,T,T,T,T,T,
    T,T,T,T,T,BOOT,BOOT,T,T,BOOT,BOOT,T,T,T,T,T,
    T,T,T,T,T,BOOT_SHADE,BOOT_SHADE,T,T,BOOT_SHADE,BOOT_SHADE,T,T,T,T,T,
  ]
}

// Facing LEFT - true side profile
export const PLAYER_LEFT = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,T,T,T,T,T,T,
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,HAIR_DARK,SKIN,SKIN,SKIN,SKIN,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,SKIN,SKIN,EYE,SKIN,SKIN,SKIN,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,SKIN,SKIN,SKIN,SKIN,SKIN_SHADE,SKIN,SKIN,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,SKIN,'#c66',SKIN,SKIN,SKIN,SKIN_SHADE,T,T,T,T,T,T,
    T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,T,T,
    T,T,T,T,T,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,
    T,T,T,T,SKIN,SHIRT,SHIRT,BELT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,
    T,T,T,SKIN,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,
    T,T,T,T,SKIN,SHIRT_SHADE,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,T,
    T,T,T,T,T,T,PANTS,PANTS,PANTS_SHADE,T,T,T,T,T,T,T,
    T,T,T,T,T,T,PANTS,PANTS_SHADE,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,BOOT,BOOT,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,BOOT_SHADE,BOOT_SHADE,T,T,T,T,T,T,T,T,
  ]
}

// Facing RIGHT - true side profile (mirrored)
export const PLAYER_RIGHT = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,T,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,T,
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,SKIN,SKIN,SKIN,SKIN,HAIR_DARK,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,SKIN,SKIN,SKIN,EYE,SKIN,SKIN,T,T,T,T,
    T,T,T,T,T,HAIR_DARK,SKIN,SKIN,SKIN_SHADE,SKIN,SKIN,SKIN,SKIN,T,T,T,
    T,T,T,T,T,T,SKIN_SHADE,SKIN,SKIN,SKIN,'#c66',SKIN,T,T,T,T,
    T,T,T,T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,
    T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,T,T,T,T,T,
    T,T,T,T,T,T,SHIRT_SHADE,SHIRT,BELT,SHIRT,SHIRT,SKIN,T,T,T,T,
    T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SKIN,T,T,T,
    T,T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,T,
    T,T,T,T,T,T,T,PANTS_SHADE,PANTS,PANTS,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,PANTS_SHADE,PANTS,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,BOOT,BOOT,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,BOOT_SHADE,BOOT_SHADE,T,T,T,T,T,T,
  ]
}

// Walking animation frames - DOWN direction
// Walk frame 1: left leg forward, right arm forward, head slightly left
export const PLAYER_DOWN_WALK1 = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,HAIR_DARK,HAIR,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,HAIR,HAIR_DARK,T,T,T,
    T,T,HAIR_DARK,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,HAIR_DARK,T,T,T,
    T,T,T,SKIN,EYE,'#fff',SKIN,SKIN,SKIN,'#fff',EYE,SKIN,T,T,T,T,
    T,T,T,SKIN,SKIN,SKIN,SKIN,SKIN_SHADE,SKIN_SHADE,SKIN,SKIN,SKIN,T,T,T,T,
    T,T,T,T,SKIN,SKIN,'#c66','#c66',SKIN,SKIN,SKIN,T,T,T,T,T,
    T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,T,
    T,T,T,SHIRT_LIGHT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_LIGHT,T,T,T,T,
    T,T,SKIN,SHIRT,SHIRT,SHIRT,SHIRT,BELT,BELT,SHIRT,SHIRT,SHIRT,SKIN,T,T,T,
    T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,
    T,T,T,SKIN,SHIRT_SHADE,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,
    T,T,T,T,PANTS,PANTS,PANTS,T,PANTS,PANTS,PANTS,T,T,T,T,T,
    T,T,T,T,PANTS,PANTS_SHADE,T,T,T,PANTS_SHADE,PANTS,T,T,T,T,T,
    T,T,T,T,BOOT,BOOT,T,T,T,T,BOOT,BOOT,T,T,T,T,
    T,T,T,T,BOOT_SHADE,T,T,T,T,T,T,BOOT_SHADE,T,T,T,T,
  ]
}

// Walk frame 2: right leg forward, left arm forward, head slightly right
export const PLAYER_DOWN_WALK2 = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,HAIR_DARK,HAIR,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,HAIR,HAIR_DARK,T,T,T,
    T,T,T,HAIR_DARK,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,SKIN,HAIR_DARK,T,T,T,
    T,T,T,T,SKIN,EYE,'#fff',SKIN,SKIN,'#fff',EYE,SKIN,T,T,T,T,
    T,T,T,T,SKIN,SKIN,SKIN,SKIN_SHADE,SKIN_SHADE,SKIN,SKIN,SKIN,T,T,T,T,
    T,T,T,T,T,SKIN,SKIN,'#c66','#c66',SKIN,SKIN,T,T,T,T,T,
    T,T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,
    T,T,T,T,SHIRT_LIGHT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_LIGHT,T,T,T,T,
    T,T,T,SKIN,SHIRT,SHIRT,SHIRT,BELT,BELT,SHIRT,SHIRT,SHIRT,SKIN,T,T,T,
    T,T,T,SKIN,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,
    T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,T,
    T,T,T,T,T,PANTS,PANTS,T,PANTS,PANTS,PANTS,T,T,T,T,T,
    T,T,T,T,T,PANTS,PANTS_SHADE,T,T,PANTS_SHADE,PANTS,T,T,T,T,T,
    T,T,T,T,BOOT,BOOT,T,T,T,T,BOOT,BOOT,T,T,T,T,
    T,T,T,BOOT_SHADE,T,T,T,T,T,T,T,T,BOOT_SHADE,T,T,T,
  ]
}

// Walking animation frames - UP direction
export const PLAYER_UP_WALK1 = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,
    T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,
    T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,T,
    T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,T,
    T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,
    T,T,SKIN,SHIRT_SHADE,SHIRT,SHIRT,BELT,BELT,SHIRT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,T,
    T,T,T,SHIRT_SHADE,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,SHIRT_SHADE,SKIN,T,T,T,T,
    T,T,T,SKIN,SHIRT_SHADE,SHIRT_SHADE,SHIRT,SHIRT,SHIRT_SHADE,SHIRT_SHADE,T,T,T,T,T,T,
    T,T,T,T,PANTS_SHADE,PANTS,PANTS,T,PANTS,PANTS,PANTS_SHADE,T,T,T,T,T,
    T,T,T,T,PANTS_SHADE,PANTS_SHADE,T,T,T,PANTS_SHADE,PANTS_SHADE,T,T,T,T,T,
    T,T,T,T,BOOT,BOOT,T,T,T,T,BOOT,BOOT,T,T,T,T,
    T,T,T,T,BOOT_SHADE,T,T,T,T,T,T,BOOT_SHADE,T,T,T,T,
  ]
}

export const PLAYER_UP_WALK2 = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,
    T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,
    T,T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,
    T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,
    T,T,T,T,SKIN,SHIRT_SHADE,SHIRT,BELT,BELT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,T,
    T,T,T,T,SKIN,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,SHIRT_SHADE,T,T,T,T,
    T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT_SHADE,SHIRT_SHADE,SKIN,T,T,T,T,
    T,T,T,T,T,PANTS_SHADE,PANTS,T,PANTS,PANTS,PANTS_SHADE,T,T,T,T,T,
    T,T,T,T,T,PANTS_SHADE,PANTS_SHADE,T,T,PANTS_SHADE,PANTS_SHADE,T,T,T,T,T,
    T,T,T,T,BOOT,BOOT,T,T,T,T,BOOT,BOOT,T,T,T,T,
    T,T,T,BOOT_SHADE,T,T,T,T,T,T,T,T,BOOT_SHADE,T,T,T,
  ]
}

// Walking animation frames - LEFT direction
export const PLAYER_LEFT_WALK1 = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,T,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,HAIR_DARK,SKIN,SKIN,SKIN,SKIN,SKIN,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,SKIN,SKIN,EYE,SKIN,SKIN,SKIN,SKIN,HAIR,HAIR_DARK,T,T,T,T,
    T,T,SKIN,SKIN,SKIN,SKIN,SKIN_SHADE,SKIN,SKIN,HAIR_DARK,T,T,T,T,T,T,
    T,T,T,SKIN,'#c66',SKIN,SKIN,SKIN,SKIN_SHADE,T,T,T,T,T,T,T,
    T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,T,T,T,
    T,T,T,T,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,T,
    T,T,T,SKIN,SHIRT,SHIRT,BELT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,T,T,T,
    T,T,SKIN,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,T,
    T,T,T,SKIN,SHIRT_SHADE,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,T,T,
    T,T,T,T,PANTS,PANTS,PANTS_SHADE,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,PANTS,T,PANTS_SHADE,T,T,T,T,T,T,T,T,
    T,T,T,T,T,BOOT,T,T,BOOT,T,T,T,T,T,T,T,
    T,T,T,T,T,BOOT_SHADE,T,T,BOOT_SHADE,T,T,T,T,T,T,T,
  ]
}

export const PLAYER_LEFT_WALK2 = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,T,T,T,T,T,T,
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,HAIR_DARK,SKIN,SKIN,SKIN,SKIN,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,SKIN,SKIN,EYE,SKIN,SKIN,SKIN,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,SKIN,SKIN,SKIN,SKIN,SKIN_SHADE,SKIN,SKIN,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,SKIN,'#c66',SKIN,SKIN,SKIN,SKIN_SHADE,T,T,T,T,T,T,
    T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,T,T,T,
    T,T,T,T,T,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,
    T,T,T,T,SKIN,SHIRT,SHIRT,BELT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,T,T,
    T,T,T,SKIN,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,
    T,T,T,T,SKIN,SHIRT_SHADE,SHIRT,SHIRT,SHIRT_SHADE,T,T,T,T,T,T,T,
    T,T,T,T,T,PANTS,PANTS,PANTS_SHADE,T,T,T,T,T,T,T,T,
    T,T,T,T,PANTS_SHADE,T,T,PANTS,T,T,T,T,T,T,T,T,
    T,T,T,T,BOOT,T,T,T,BOOT,T,T,T,T,T,T,T,
    T,T,T,T,BOOT_SHADE,T,T,T,BOOT_SHADE,T,T,T,T,T,T,T,
  ]
}

// Walking animation frames - RIGHT direction
export const PLAYER_RIGHT_WALK1 = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,T,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,T,
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,SKIN,SKIN,SKIN,SKIN,HAIR_DARK,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,SKIN,SKIN,SKIN,EYE,SKIN,SKIN,T,T,T,T,
    T,T,T,T,T,T,HAIR_DARK,SKIN,SKIN,SKIN_SHADE,SKIN,SKIN,SKIN,SKIN,T,T,
    T,T,T,T,T,T,T,SKIN_SHADE,SKIN,SKIN,SKIN,'#c66',SKIN,T,T,T,
    T,T,T,T,T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,
    T,T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,T,T,T,T,
    T,T,T,T,T,T,SKIN,SHIRT_SHADE,SHIRT,BELT,SHIRT,SHIRT,SKIN,T,T,T,
    T,T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SKIN,T,T,
    T,T,T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,
    T,T,T,T,T,T,T,T,PANTS_SHADE,PANTS,PANTS,T,T,T,T,T,
    T,T,T,T,T,T,T,T,PANTS_SHADE,T,PANTS,T,T,T,T,T,
    T,T,T,T,T,T,T,BOOT,T,T,BOOT,T,T,T,T,T,
    T,T,T,T,T,T,T,BOOT_SHADE,T,T,BOOT_SHADE,T,T,T,T,T,
  ]
}

export const PLAYER_RIGHT_WALK2 = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,T,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,T,
    T,T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR,HAIR_DARK,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,HAIR,SKIN,SKIN,SKIN,SKIN,HAIR_DARK,T,T,T,T,
    T,T,T,T,HAIR_DARK,HAIR,SKIN,SKIN,SKIN,EYE,SKIN,SKIN,T,T,T,T,
    T,T,T,T,T,HAIR_DARK,SKIN,SKIN,SKIN_SHADE,SKIN,SKIN,SKIN,SKIN,T,T,T,
    T,T,T,T,T,T,SKIN_SHADE,SKIN,SKIN,SKIN,'#c66',SKIN,T,T,T,T,
    T,T,T,T,T,T,T,T,SKIN_SHADE,SKIN_SHADE,SKIN_SHADE,T,T,T,T,T,
    T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,T,T,T,T,T,
    T,T,T,T,T,SKIN,SHIRT_SHADE,SHIRT,BELT,SHIRT,SHIRT,SKIN,T,T,T,T,
    T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT,SHIRT,SHIRT,SKIN,T,T,T,
    T,T,T,T,T,T,T,SHIRT_SHADE,SHIRT,SHIRT,SHIRT_SHADE,SKIN,T,T,T,T,
    T,T,T,T,T,T,T,T,PANTS_SHADE,PANTS,PANTS,T,T,T,T,T,
    T,T,T,T,T,T,T,PANTS,T,T,PANTS_SHADE,T,T,T,T,T,
    T,T,T,T,T,T,BOOT,T,T,T,BOOT,T,T,T,T,T,
    T,T,T,T,T,T,BOOT_SHADE,T,T,T,BOOT_SHADE,T,T,T,T,T,
  ]
}

// Player sprites grouped by direction (static)
export const PLAYER_SPRITES = {
  up: PLAYER_UP,
  down: PLAYER_DOWN,
  left: PLAYER_LEFT,
  right: PLAYER_RIGHT
}

// Walking animation frames grouped by direction
export const PLAYER_WALK_SPRITES = {
  up: [PLAYER_UP, PLAYER_UP_WALK1, PLAYER_UP, PLAYER_UP_WALK2],
  down: [PLAYER_DOWN, PLAYER_DOWN_WALK1, PLAYER_DOWN, PLAYER_DOWN_WALK2],
  left: [PLAYER_LEFT, PLAYER_LEFT_WALK1, PLAYER_LEFT, PLAYER_LEFT_WALK2],
  right: [PLAYER_RIGHT, PLAYER_RIGHT_WALK1, PLAYER_RIGHT, PLAYER_RIGHT_WALK2]
}

// Keep for backward compatibility
export const PLAYER_SPRITE = PLAYER_DOWN

// Zombie sprite (16x16)
// --- Zombie directional sprites (16x16) ---
const ZS = '#7a7' // zombie skin
const ZD = '#585' // zombie skin dark
const ZE = '#300' // zombie eye
const ZT = '#474' // zombie shirt
const ZP = '#363' // zombie pants
const ZB = '#252' // zombie boot

export const ZOMBIE_DOWN = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,ZD,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,
    T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,T,
    T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,
    T,T,T,ZD,ZS,ZE,ZS,ZS,ZS,ZE,ZS,ZS,ZD,T,T,T,
    T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,
    T,T,T,T,ZD,ZS,ZD,ZD,ZD,ZD,ZS,ZD,T,T,T,T,
    T,T,T,T,T,ZD,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,
    T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,
    T,T,T,ZS,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,
    T,T,T,ZS,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,
    T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,
    T,T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,
    T,T,T,T,T,ZP,ZP,T,T,ZP,ZP,T,T,T,T,T,
    T,T,T,T,T,ZP,ZP,T,T,ZP,ZP,T,T,T,T,T,
    T,T,T,T,T,ZB,ZB,T,T,ZB,ZB,T,T,T,T,T,
    T,T,T,T,T,ZB,ZB,T,T,ZB,ZB,T,T,T,T,T,
  ]
}
export const ZOMBIE_UP = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,ZD,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,
    T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,T,
    T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,
    T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,
    T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,
    T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,T,
    T,T,T,T,T,ZD,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,
    T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,
    T,T,T,ZS,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,
    T,T,T,ZS,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,
    T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,
    T,T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,
    T,T,T,T,T,ZP,ZP,T,T,ZP,ZP,T,T,T,T,T,
    T,T,T,T,T,ZP,ZP,T,T,ZP,ZP,T,T,T,T,T,
    T,T,T,T,T,ZB,ZB,T,T,ZB,ZB,T,T,T,T,T,
    T,T,T,T,T,ZB,ZB,T,T,ZB,ZB,T,T,T,T,T,
  ]
}
export const ZOMBIE_LEFT = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,T,ZD,ZD,ZD,ZD,T,T,T,T,T,T,
    T,T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZD,T,T,T,T,T,
    T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,T,
    T,T,T,T,ZD,ZS,ZE,ZS,ZS,ZS,ZS,ZD,T,T,T,T,
    T,T,T,T,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,T,T,
    T,T,T,T,T,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,T,
    T,T,T,T,T,ZD,ZD,ZD,ZD,T,T,T,T,T,T,T,
    T,T,T,T,T,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,T,
    T,T,T,T,ZS,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,T,
    T,T,T,ZS,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,T,
    T,T,T,T,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,T,T,
    T,T,T,T,T,ZT,ZT,ZT,ZT,T,T,T,T,T,T,T,
    T,T,T,T,T,T,ZP,ZP,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,ZP,ZP,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,ZB,ZB,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,ZB,ZB,T,T,T,T,T,T,T,T,
  ]
}
export const ZOMBIE_RIGHT = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,T,ZD,ZD,ZD,ZD,T,T,T,T,T,T,
    T,T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZD,T,T,T,T,T,
    T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,T,
    T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZE,ZS,ZD,T,T,T,T,
    T,T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,T,T,T,T,
    T,T,T,T,T,T,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,
    T,T,T,T,T,T,T,ZD,ZD,ZD,ZD,T,T,T,T,T,
    T,T,T,T,T,T,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,
    T,T,T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,T,
    T,T,T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,
    T,T,T,T,T,T,T,ZT,ZT,ZT,ZT,ZT,T,T,T,T,
    T,T,T,T,T,T,T,ZT,ZT,ZT,ZT,T,T,T,T,T,
    T,T,T,T,T,T,T,T,ZP,ZP,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,ZP,ZP,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,ZB,ZB,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,ZB,ZB,T,T,T,T,T,T,
  ]
}
export const ZOMBIE_DOWN_WALK1 = {
  width: 16, height: 16, pixels: [
    T,T,T,T,ZD,ZD,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,
    T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,T,
    T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,
    T,T,ZD,ZS,ZE,ZS,ZS,ZS,ZS,ZE,ZS,ZS,ZD,T,T,T,
    T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,
    T,T,T,ZD,ZS,ZD,ZD,ZD,ZD,ZS,ZD,T,T,T,T,T,
    T,T,T,T,ZD,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,T,
    T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,
    T,T,ZS,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,
    T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,
    T,T,T,ZS,ZT,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,
    T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,T,
    T,T,T,T,ZP,ZP,T,T,T,ZP,ZP,T,T,T,T,T,
    T,T,T,T,ZP,T,T,T,T,T,ZP,T,T,T,T,T,
    T,T,T,T,ZB,T,T,T,T,T,T,ZB,T,T,T,T,
    T,T,T,ZB,T,T,T,T,T,T,T,T,ZB,T,T,T,
  ]
}
export const ZOMBIE_DOWN_WALK2 = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,ZD,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,
    T,T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,T,
    T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,
    T,T,T,ZD,ZS,ZE,ZS,ZS,ZS,ZE,ZS,ZS,ZD,T,T,T,
    T,T,T,ZD,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZS,ZD,T,T,T,
    T,T,T,T,ZD,ZS,ZD,ZD,ZD,ZD,ZS,ZD,T,T,T,T,
    T,T,T,T,T,ZD,ZD,ZD,ZD,ZD,ZD,T,T,T,T,T,
    T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,
    T,T,T,ZS,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,
    T,T,T,ZS,ZT,ZT,ZT,ZT,ZT,ZT,ZT,ZT,T,T,T,T,
    T,T,T,T,T,ZT,ZT,ZT,ZT,ZT,ZT,ZS,T,T,T,T,
    T,T,T,T,T,T,ZT,ZT,ZT,ZT,ZT,T,T,T,T,T,
    T,T,T,T,T,ZP,ZP,T,T,T,ZP,ZP,T,T,T,T,
    T,T,T,T,T,ZP,T,T,T,T,ZP,T,T,T,T,T,
    T,T,T,T,ZB,T,T,T,T,T,T,ZB,T,T,T,T,
    T,T,T,ZB,T,T,T,T,T,T,T,T,ZB,T,T,T,
  ]
}

export const ZOMBIE_SPRITES = {
  down: ZOMBIE_DOWN, up: ZOMBIE_UP, left: ZOMBIE_LEFT, right: ZOMBIE_RIGHT
}
export const ZOMBIE_WALK_SPRITES = {
  down: [ZOMBIE_DOWN, ZOMBIE_DOWN_WALK1, ZOMBIE_DOWN, ZOMBIE_DOWN_WALK2],
  up: [ZOMBIE_UP, ZOMBIE_UP, ZOMBIE_UP, ZOMBIE_UP],
  left: [ZOMBIE_LEFT, ZOMBIE_LEFT, ZOMBIE_LEFT, ZOMBIE_LEFT],
  right: [ZOMBIE_RIGHT, ZOMBIE_RIGHT, ZOMBIE_RIGHT, ZOMBIE_RIGHT],
}

export const ZOMBIE_SPRITE = ZOMBIE_DOWN

// --- Skeleton directional sprites (16x16) ---
const SK = '#fff'  // skeleton bone
const SD = '#ddd'  // skeleton bone dark
const SE = '#222'  // skeleton eye
const SC = '#ccc'  // skeleton rib
const SA = '#aaa'  // skeleton leg
const SB = '#888'  // skeleton boot

export const SKELETON_DOWN = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,SD,SD,SD,SD,SD,SD,T,T,T,T,T,
    T,T,T,T,SD,SK,SK,SK,SK,SK,SK,SD,T,T,T,T,
    T,T,T,SD,SK,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,
    T,T,T,SD,SK,SE,SK,SK,SK,SE,SK,SK,SD,T,T,T,
    T,T,T,SD,SK,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,
    T,T,T,T,SD,SK,SE,SE,SE,SE,SK,SD,T,T,T,T,
    T,T,T,T,T,SD,SD,SD,SD,SD,SD,T,T,T,T,T,
    T,T,T,T,T,SC,T,SC,SC,T,SC,T,T,T,T,T,
    T,T,T,T,SC,SC,SC,SC,SC,SC,SC,SC,T,T,T,T,
    T,T,SC,T,T,SC,SC,SC,SC,SC,SC,T,T,SC,T,T,
    T,T,SC,T,T,SC,SC,SC,SC,SC,SC,T,T,SC,T,T,
    T,T,T,T,T,SC,SC,SC,SC,SC,SC,T,T,T,T,T,
    T,T,T,T,T,SA,SA,T,T,SA,SA,T,T,T,T,T,
    T,T,T,T,T,SA,SA,T,T,SA,SA,T,T,T,T,T,
    T,T,T,T,T,SB,SB,T,T,SB,SB,T,T,T,T,T,
    T,T,T,T,T,SB,SB,T,T,SB,SB,T,T,T,T,T,
  ]
}
export const SKELETON_UP = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,SD,SD,SD,SD,SD,SD,T,T,T,T,T,
    T,T,T,T,SD,SK,SK,SK,SK,SK,SK,SD,T,T,T,T,
    T,T,T,SD,SK,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,
    T,T,T,SD,SK,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,
    T,T,T,SD,SK,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,
    T,T,T,T,SD,SK,SK,SK,SK,SK,SK,SD,T,T,T,T,
    T,T,T,T,T,SD,SD,SD,SD,SD,SD,T,T,T,T,T,
    T,T,T,T,T,SC,T,SC,SC,T,SC,T,T,T,T,T,
    T,T,T,T,SC,SC,SC,SC,SC,SC,SC,SC,T,T,T,T,
    T,T,SC,T,T,SC,SC,SC,SC,SC,SC,T,T,SC,T,T,
    T,T,SC,T,T,SC,SC,SC,SC,SC,SC,T,T,SC,T,T,
    T,T,T,T,T,SC,SC,SC,SC,SC,SC,T,T,T,T,T,
    T,T,T,T,T,SA,SA,T,T,SA,SA,T,T,T,T,T,
    T,T,T,T,T,SA,SA,T,T,SA,SA,T,T,T,T,T,
    T,T,T,T,T,SB,SB,T,T,SB,SB,T,T,T,T,T,
    T,T,T,T,T,SB,SB,T,T,SB,SB,T,T,T,T,T,
  ]
}
export const SKELETON_LEFT = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,T,SD,SD,SD,SD,T,T,T,T,T,T,
    T,T,T,T,T,SD,SK,SK,SK,SK,SD,T,T,T,T,T,
    T,T,T,T,SD,SK,SK,SK,SK,SK,SK,SD,T,T,T,T,
    T,T,T,T,SD,SK,SE,SK,SK,SK,SK,SD,T,T,T,T,
    T,T,T,T,SK,SK,SK,SK,SK,SK,SD,T,T,T,T,T,
    T,T,T,T,T,SD,SE,SE,SD,SD,T,T,T,T,T,T,
    T,T,T,T,T,SD,SD,SD,SD,T,T,T,T,T,T,T,
    T,T,T,T,T,SC,SC,SC,SC,T,T,T,T,T,T,T,
    T,T,T,T,SC,SC,SC,SC,SC,SC,T,T,T,T,T,T,
    T,T,T,SC,T,SC,SC,SC,SC,SC,T,T,T,T,T,T,
    T,T,T,T,T,SC,SC,SC,SC,T,T,T,T,T,T,T,
    T,T,T,T,T,SC,SC,SC,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,SA,SA,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,SA,SA,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,SB,SB,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,SB,SB,T,T,T,T,T,T,T,T,
  ]
}
export const SKELETON_RIGHT = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,T,SD,SD,SD,SD,T,T,T,T,T,T,
    T,T,T,T,T,SD,SK,SK,SK,SK,SD,T,T,T,T,T,
    T,T,T,T,SD,SK,SK,SK,SK,SK,SK,SD,T,T,T,T,
    T,T,T,T,SD,SK,SK,SK,SK,SE,SK,SD,T,T,T,T,
    T,T,T,T,T,SD,SK,SK,SK,SK,SK,SK,T,T,T,T,
    T,T,T,T,T,T,SD,SD,SE,SE,SD,T,T,T,T,T,
    T,T,T,T,T,T,T,SD,SD,SD,SD,T,T,T,T,T,
    T,T,T,T,T,T,SC,SC,SC,SC,T,T,T,T,T,T,
    T,T,T,T,T,T,SC,SC,SC,SC,SC,SC,T,T,T,T,
    T,T,T,T,T,T,SC,SC,SC,SC,SC,T,SC,T,T,T,
    T,T,T,T,T,T,T,SC,SC,SC,SC,T,T,T,T,T,
    T,T,T,T,T,T,T,T,SC,SC,SC,T,T,T,T,T,
    T,T,T,T,T,T,T,T,SA,SA,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,SA,SA,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,SB,SB,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,SB,SB,T,T,T,T,T,T,
  ]
}
export const SKELETON_DOWN_WALK1 = {
  width: 16, height: 16, pixels: [
    T,T,T,T,SD,SD,SD,SD,SD,SD,SD,T,T,T,T,T,
    T,T,T,SD,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,T,
    T,T,SD,SK,SK,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,
    T,T,SD,SK,SE,SK,SK,SK,SE,SK,SK,SK,SD,T,T,T,
    T,T,SD,SK,SK,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,
    T,T,T,SD,SK,SE,SE,SE,SE,SK,SD,T,T,T,T,T,
    T,T,T,T,SD,SD,SD,SD,SD,SD,T,T,T,T,T,T,
    T,T,T,T,SC,T,SC,SC,T,SC,T,T,T,T,T,T,
    T,T,T,SC,SC,SC,SC,SC,SC,SC,SC,T,T,T,T,T,
    T,T,SC,T,SC,SC,SC,SC,SC,SC,T,SC,T,T,T,T,
    T,T,T,T,SC,SC,SC,SC,SC,SC,T,T,T,T,T,T,
    T,T,T,T,T,SC,SC,SC,SC,T,T,T,T,T,T,T,
    T,T,T,T,SA,SA,T,T,T,SA,SA,T,T,T,T,T,
    T,T,T,T,SA,T,T,T,T,T,SA,T,T,T,T,T,
    T,T,T,SB,T,T,T,T,T,T,T,SB,T,T,T,T,
    T,T,SB,T,T,T,T,T,T,T,T,T,SB,T,T,T,
  ]
}
export const SKELETON_DOWN_WALK2 = {
  width: 16, height: 16, pixels: [
    T,T,T,T,T,SD,SD,SD,SD,SD,SD,T,T,T,T,T,
    T,T,T,T,SD,SK,SK,SK,SK,SK,SK,SD,T,T,T,T,
    T,T,T,SD,SK,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,
    T,T,T,SD,SK,SE,SK,SK,SK,SE,SK,SK,SD,T,T,T,
    T,T,T,SD,SK,SK,SK,SK,SK,SK,SK,SK,SD,T,T,T,
    T,T,T,T,SD,SK,SE,SE,SE,SE,SK,SD,T,T,T,T,
    T,T,T,T,T,SD,SD,SD,SD,SD,SD,T,T,T,T,T,
    T,T,T,T,T,SC,T,SC,SC,T,SC,T,T,T,T,T,
    T,T,T,T,T,SC,SC,SC,SC,SC,SC,SC,T,T,T,T,
    T,T,T,T,SC,T,SC,SC,SC,SC,SC,T,SC,T,T,T,
    T,T,T,T,T,T,SC,SC,SC,SC,SC,T,T,T,T,T,
    T,T,T,T,T,T,T,SC,SC,SC,T,T,T,T,T,T,
    T,T,T,T,T,SA,SA,T,T,T,SA,SA,T,T,T,T,
    T,T,T,T,T,SA,T,T,T,T,SA,T,T,T,T,T,
    T,T,T,T,SB,T,T,T,T,T,T,SB,T,T,T,T,
    T,T,T,SB,T,T,T,T,T,T,T,T,SB,T,T,T,
  ]
}

export const SKELETON_SPRITES = {
  down: SKELETON_DOWN, up: SKELETON_UP, left: SKELETON_LEFT, right: SKELETON_RIGHT
}
export const SKELETON_WALK_SPRITES = {
  down: [SKELETON_DOWN, SKELETON_DOWN_WALK1, SKELETON_DOWN, SKELETON_DOWN_WALK2],
  up: [SKELETON_UP, SKELETON_UP, SKELETON_UP, SKELETON_UP],
  left: [SKELETON_LEFT, SKELETON_LEFT, SKELETON_LEFT, SKELETON_LEFT],
  right: [SKELETON_RIGHT, SKELETON_RIGHT, SKELETON_RIGHT, SKELETON_RIGHT],
}

export const SKELETON_SPRITE = SKELETON_DOWN

// Spider sprite (16x16)
export const SPIDER_SPRITE = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,'#333',T,T,T,T,T,T,T,T,T,T,T,T,'#333',T,
    T,T,'#333',T,T,T,T,T,T,T,T,T,T,'#333',T,T,
    T,T,T,'#333',T,T,'#444','#444','#444','#444',T,T,'#333',T,T,T,
    T,'#333',T,T,'#333','#444','#555','#555','#555','#555','#444','#333',T,T,'#333',T,
    T,T,'#333','#444','#555','#500','#555','#555','#555','#555','#500','#555','#444','#333',T,T,
    T,T,T,'#444','#555','#555','#555','#555','#555','#555','#555','#555','#444',T,T,T,
    T,T,'#333','#444','#555','#555','#555','#555','#555','#555','#555','#555','#444','#333',T,T,
    T,'#333',T,T,'#333','#444','#555','#555','#555','#555','#444','#333',T,T,'#333',T,
    T,T,'#333',T,T,T,'#444','#444','#444','#444',T,T,T,'#333',T,T,
    T,T,T,'#333',T,T,T,T,T,T,T,T,'#333',T,T,T,
    T,'#333',T,T,T,T,T,T,T,T,T,T,T,T,'#333',T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
  ]
}

// Orc sprite (16x16)
export const ORC_SPRITE = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,'#4a4','#4a4','#4a4','#4a4','#4a4','#4a4',T,T,T,T,T,
    T,T,T,T,'#4a4','#6c6','#6c6','#6c6','#6c6','#6c6','#6c6','#4a4',T,T,T,T,
    T,T,T,'#4a4','#6c6','#6c6','#6c6','#6c6','#6c6','#6c6','#6c6','#6c6','#4a4',T,T,T,
    T,T,T,'#4a4','#6c6','#a00','#6c6','#6c6','#6c6','#6c6','#a00','#6c6','#4a4',T,T,T,
    T,T,T,'#4a4','#6c6','#6c6','#6c6','#6c6','#6c6','#6c6','#6c6','#6c6','#4a4',T,T,T,
    T,T,T,T,'#4a4','#6c6','#fff','#6c6','#6c6','#fff','#6c6','#4a4',T,T,T,T,
    T,T,T,T,T,'#4a4','#4a4','#4a4','#4a4','#4a4','#4a4',T,T,T,T,T,
    T,T,T,'#654','#654','#654','#654','#654','#654','#654','#654','#654','#654',T,T,T,
    T,T,'#654','#765','#765','#765','#765','#765','#765','#765','#765','#765','#765','#654',T,T,
    T,'#6c6','#654','#765','#765','#765','#765','#765','#765','#765','#765','#765','#765','#654','#6c6',T,
    T,'#6c6','#654','#765','#765','#765','#765','#765','#765','#765','#765','#765','#765','#654','#6c6',T,
    T,T,'#654','#765','#765','#765','#765','#765','#765','#765','#765','#765','#765','#654',T,T,
    T,T,T,'#654','#654','#654','#654','#654','#654','#654','#654','#654','#654',T,T,T,
    T,T,T,T,'#4a4','#4a4',T,T,T,T,'#4a4','#4a4',T,T,T,T,
    T,T,T,T,'#4a4','#4a4',T,T,T,T,'#4a4','#4a4',T,T,T,T,
    T,T,T,T,'#383','#383',T,T,T,T,'#383','#383',T,T,T,T,
  ]
}

// Dark Knight sprite (16x16)
export const DARK_KNIGHT_SPRITE = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,'#333','#444','#444','#444','#444','#444','#444','#333',T,T,T,T,
    T,T,T,'#333','#444','#555','#555','#555','#555','#555','#555','#444','#333',T,T,T,
    T,T,T,'#333','#444','#555','#555','#555','#555','#555','#555','#444','#333',T,T,T,
    T,T,T,'#333','#444','#a00','#444','#444','#444','#444','#a00','#444','#333',T,T,T,
    T,T,T,'#333','#444','#444','#555','#555','#555','#555','#444','#444','#333',T,T,T,
    T,T,T,T,'#333','#444','#444','#444','#444','#444','#444','#333',T,T,T,T,
    T,T,T,T,T,'#333','#333','#333','#333','#333','#333',T,T,T,T,T,
    T,T,T,'#333','#444','#444','#444','#444','#444','#444','#444','#444','#333',T,T,T,
    T,T,'#333','#444','#555','#555','#555','#555','#555','#555','#555','#555','#444','#333',T,T,
    T,'#555','#333','#444','#555','#555','#555','#555','#555','#555','#555','#555','#444','#333','#555',T,
    T,'#555','#333','#444','#555','#555','#555','#555','#555','#555','#555','#555','#444','#333','#555',T,
    T,T,'#333','#444','#555','#555','#555','#555','#555','#555','#555','#555','#444','#333',T,T,
    T,T,T,'#333','#444','#444','#444','#444','#444','#444','#444','#444','#333',T,T,T,
    T,T,T,T,'#333','#333',T,T,T,T,'#333','#333',T,T,T,T,
    T,T,T,T,'#444','#444',T,T,T,T,'#444','#444',T,T,T,T,
    T,T,T,T,'#333','#333',T,T,T,T,'#333','#333',T,T,T,T,
  ]
}

// Shadow Wolf sprite (16x16)
export const SHADOW_WOLF_SPRITE = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,'#222',T,T,T,T,T,T,T,T,T,T,'#222',T,T,
    T,'#222','#333','#222',T,T,T,T,T,T,T,T,'#222','#333','#222',T,
    T,T,'#222','#333','#333','#333',T,T,T,T,'#333','#333','#333','#222',T,T,
    T,T,T,'#333','#444','#444','#333','#333','#333','#333','#444','#444','#333',T,T,T,
    T,T,T,'#333','#a0a','#444','#444','#444','#444','#444','#444','#a0a','#333',T,T,T,
    T,T,T,T,'#333','#444','#444','#444','#444','#444','#444','#333',T,T,T,T,
    T,T,T,T,'#333','#444','#444','#444','#444','#444','#444','#333',T,T,T,T,
    T,T,T,'#333','#444','#444','#444','#444','#444','#444','#444','#444','#333',T,T,T,
    T,T,'#333','#444','#444','#444','#444','#444','#444','#444','#444','#444','#444','#333',T,T,
    T,T,'#333','#444','#444','#444','#444','#444','#444','#444','#444','#444','#444','#333',T,T,
    T,T,T,'#333','#333',T,'#333','#333','#333','#333',T,'#333','#333',T,T,T,
    T,T,T,'#222','#222',T,'#222','#222','#222','#222',T,'#222','#222',T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
  ]
}

// Dark Wizard sprite (16x16)
export const DARK_WIZARD_SPRITE = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,T,'#409','#409','#409','#409',T,T,T,T,T,T,
    T,T,T,T,T,'#409','#409','#409','#409','#409','#409',T,T,T,T,T,
    T,T,T,T,'#409','#409','#409','#409','#409','#409','#409','#409',T,T,T,T,
    T,T,T,'#409','#409','#409','#409','#409','#409','#409','#409','#409','#409',T,T,T,
    T,T,T,'#409','#fdb','#fdb','#fdb','#fdb','#fdb','#fdb','#fdb','#fdb','#409',T,T,T,
    T,T,T,'#409','#fdb','#a0a','#fdb','#fdb','#fdb','#fdb','#a0a','#fdb','#409',T,T,T,
    T,T,T,T,'#409','#fdb','#fdb','#fdb','#fdb','#fdb','#fdb','#409',T,T,T,T,
    T,T,T,T,'#306','#409','#409','#409','#409','#409','#409','#306',T,T,T,T,
    T,T,T,'#306','#409','#409','#409','#409','#409','#409','#409','#409','#306',T,T,T,
    T,T,'#306','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#306',T,T,
    T,T,'#306','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#306',T,T,
    T,T,T,'#306','#409','#409','#409','#409','#409','#409','#409','#409','#306',T,T,T,
    T,T,T,'#306','#306','#409','#409','#409','#409','#409','#409','#306','#306',T,T,T,
    T,T,T,T,'#306','#306','#306','#306','#306','#306','#306','#306',T,T,T,T,
    T,T,T,T,'#306','#306',T,T,T,T,'#306','#306',T,T,T,T,
    T,T,T,T,'#204','#204',T,T,T,T,'#204','#204',T,T,T,T,
  ]
}

function recolorSprite(sprite, palette) {
  return {
    ...sprite,
    pixels: sprite.pixels.map(color => palette[color] || color)
  }
}

export const EMBER_GUARD_SPRITE = recolorSprite(DARK_KNIGHT_SPRITE, {
  '#333': '#4b1d12',
  '#444': '#7a2f18',
  '#555': '#b94d1d',
  '#a00': '#ffd45a'
})

export const CINDER_IMP_SPRITE = recolorSprite(DARK_WIZARD_SPRITE, {
  '#204': '#471308',
  '#306': '#7c2510',
  '#409': '#c74316',
  '#a0a': '#ffe36b',
  '#fdb': '#ff9b3d'
})

// Dark King sprite (20x20 - bigger boss)
export const DARK_KING_SPRITE = {
  width: 20,
  height: 20,
  pixels: [
    T,T,T,T,T,T,'#a0a',T,T,'#ff0','#ff0',T,T,'#a0a',T,T,T,T,T,T,
    T,T,T,T,T,'#a0a','#c0c','#a0a',T,'#ff0','#ff0',T,'#a0a','#c0c','#a0a',T,T,T,T,T,
    T,T,T,T,'#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409',T,T,T,T,
    T,T,T,'#409','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#409',T,T,T,
    T,T,'#409','#50a','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#50a','#409',T,T,
    T,T,'#409','#50a','#60b','#f00','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#f00','#60b','#50a','#409',T,T,
    T,T,'#409','#50a','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#50a','#409',T,T,
    T,T,T,'#409','#50a','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#60b','#50a','#409',T,T,T,
    T,T,T,T,'#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409',T,T,T,T,
    T,T,T,'#306','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#306',T,T,T,
    T,T,'#306','#409','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#409','#306',T,T,
    T,'#60b','#306','#409','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#409','#306','#60b',T,
    T,'#60b','#306','#409','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#409','#306','#60b',T,
    T,T,'#306','#409','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#50a','#409','#306',T,T,
    T,T,T,'#306','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#306',T,T,T,
    T,T,T,'#306','#306','#409','#409','#409','#409','#409','#409','#409','#409','#409','#409','#306','#306',T,T,T,
    T,T,T,T,'#306','#306','#306','#306','#306','#306','#306','#306','#306','#306','#306','#306',T,T,T,T,
    T,T,T,T,T,'#306','#306',T,T,T,T,T,T,'#306','#306',T,T,T,T,T,
    T,T,T,T,T,'#409','#409',T,T,T,T,T,T,'#409','#409',T,T,T,T,T,
    T,T,T,T,T,'#306','#306',T,T,T,T,T,T,'#306','#306',T,T,T,T,T,
  ]
}

// Tree sprite (for forest) - 16x16 centered
export const TREE_SPRITE = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,T,T,'#2a2','#3b3','#3b3','#2a2',T,T,T,T,T,T,
    T,T,T,T,'#2a2','#3b3','#4c4','#5d5','#5d5','#4c4','#3b3','#2a2',T,T,T,T,
    T,T,T,'#2a2','#3b3','#4c4','#5d5','#6e6','#6e6','#5d5','#4c4','#3b3','#2a2',T,T,T,
    T,T,'#2a2','#3b3','#4c4','#5d5','#6e6','#6e6','#6e6','#6e6','#5d5','#4c4','#3b3','#2a2',T,T,
    T,'#2a2','#3b3','#4c4','#5d5','#6e6','#6e6','#6e6','#6e6','#6e6','#6e6','#5d5','#4c4','#3b3','#2a2',T,
    T,'#2a2','#3b3','#4c4','#5d5','#6e6','#6e6','#6e6','#6e6','#6e6','#6e6','#5d5','#4c4','#3b3','#2a2',T,
    '#2a2','#3b3','#4c4','#5d5','#5d5','#6e6','#6e6','#6e6','#6e6','#6e6','#6e6','#5d5','#5d5','#4c4','#3b3','#2a2',
    '#2a2','#3b3','#4c4','#5d5','#5d5','#6e6','#6e6','#6e6','#6e6','#6e6','#6e6','#5d5','#5d5','#4c4','#3b3','#2a2',
    T,'#2a2','#3b3','#4c4','#5d5','#5d5','#6e6','#6e6','#6e6','#6e6','#5d5','#5d5','#4c4','#3b3','#2a2',T,
    T,T,'#2a2','#3b3','#4c4','#5d5','#5d5','#5d5','#5d5','#5d5','#5d5','#4c4','#3b3','#2a2',T,T,
    T,T,T,'#2a2','#3b3','#4c4','#4c4','#5d5','#5d5','#4c4','#4c4','#3b3','#2a2',T,T,T,
    T,T,T,T,T,T,'#654','#765','#765','#654',T,T,T,T,T,T,
    T,T,T,T,T,T,'#654','#765','#765','#654',T,T,T,T,T,T,
    T,T,T,T,T,T,'#543','#654','#654','#543',T,T,T,T,T,T,
    T,T,T,T,T,T,'#543','#654','#654','#543',T,T,T,T,T,T,
    T,T,T,T,T,T,'#432','#543','#543','#432',T,T,T,T,T,T,
  ]
}

export const LARGE_TREE_SPRITE = {
  width: 24,
  height: 28,
  pixels: Array.from({ length: 24 * 28 }, (_, index) => {
    const x = index % 24
    const y = Math.floor(index / 24)
    const sourceX = Math.floor(x * TREE_SPRITE.width / 24)
    const sourceY = Math.floor(y * TREE_SPRITE.height / 28)
    return TREE_SPRITE.pixels[sourceY * TREE_SPRITE.width + sourceX]
  })
}

// Gravestone sprite (16x16 to fill a tile)
export const GRAVESTONE_SPRITE = {
  width: 16,
  height: 16,
  pixels: [
    T,T,T,T,'#666','#777','#888','#888','#888','#888','#777','#666',T,T,T,T,
    T,T,T,'#666','#888','#999','#aaa','#aaa','#aaa','#aaa','#999','#888','#666',T,T,T,
    T,T,'#666','#888','#999','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#999','#888','#666',T,T,
    T,T,'#777','#999','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#999','#777',T,T,
    T,T,'#777','#999','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#999','#777',T,T,
    T,T,'#777','#999','#aaa','#777','#777','#aaa','#aaa','#777','#aaa','#aaa','#999','#777',T,T,
    T,T,'#777','#999','#aaa','#777','#aaa','#aaa','#aaa','#777','#aaa','#aaa','#999','#777',T,T,
    T,T,'#777','#999','#aaa','#777','#777','#aaa','#aaa','#777','#aaa','#aaa','#999','#777',T,T,
    T,T,'#777','#999','#aaa','#777','#aaa','#777','#aaa','#777','#aaa','#aaa','#999','#777',T,T,
    T,T,'#777','#999','#aaa','#777','#aaa','#aaa','#777','#777','#777','#aaa','#999','#777',T,T,
    T,T,'#777','#999','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#999','#777',T,T,
    T,T,'#777','#999','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#aaa','#999','#777',T,T,
    T,T,'#666','#888','#999','#999','#999','#999','#999','#999','#999','#999','#888','#666',T,T,
    T,'#555','#666','#777','#888','#888','#888','#888','#888','#888','#888','#888','#777','#666','#555',T,
    T,'#555','#555','#666','#666','#777','#777','#777','#777','#777','#777','#666','#666','#555','#555',T,
    T,T,'#444','#555','#555','#555','#666','#666','#666','#666','#555','#555','#555','#444',T,T,
  ]
}

// Chest sprite
export const CHEST_SPRITE = {
  width: 12,
  height: 10,
  pixels: [
    T,'#a62','#a62','#a62','#a62','#a62','#a62','#a62','#a62','#a62','#a62',T,
    '#a62','#c84','#c84','#c84','#c84','#ff0','#ff0','#c84','#c84','#c84','#c84','#a62',
    '#a62','#c84','#c84','#c84','#c84','#ff0','#ff0','#c84','#c84','#c84','#c84','#a62',
    '#a62','#c84','#c84','#c84','#c84','#c84','#c84','#c84','#c84','#c84','#c84','#a62',
    '#851','#a62','#a62','#a62','#a62','#a62','#a62','#a62','#a62','#a62','#a62','#851',
    '#851','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#851',
    '#851','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#851',
    '#851','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#851',
    '#851','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#851',
    T,'#740','#740','#740','#740','#740','#740','#740','#740','#740','#740',T,
  ]
}

export const OPEN_CHEST_SPRITE = {
  width: 12,
  height: 10,
  pixels: [
    T,T,'#740','#851','#851','#851','#851','#851','#851','#740',T,T,
    T,'#740','#a62','#c84','#c84','#c84','#c84','#c84','#c84','#a62','#740',T,
    '#740','#a62','#c84','#c84','#c84','#ff0','#ff0','#c84','#c84','#c84','#a62','#740',
    '#851','#a62','#740','#740','#740','#740','#740','#740','#740','#740','#a62','#851',
    '#851','#210','#210','#210','#210','#210','#210','#210','#210','#210','#210','#851',
    '#851','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#851',
    '#851','#b73','#b73','#b73','#b73','#ff0','#ff0','#b73','#b73','#b73','#b73','#851',
    '#851','#b73','#b73','#b73','#b73','#ff0','#ff0','#b73','#b73','#b73','#b73','#851',
    '#851','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#b73','#851',
    T,'#740','#740','#740','#740','#740','#740','#740','#740','#740','#740',T,
  ]
}

// Item drop sprite (glowing orb)
export const ITEM_DROP_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    T,T,'#ff8','#ff8','#ff8','#ff8',T,T,
    T,'#ff8','#ffa','#ffa','#ffa','#ffa','#ff8',T,
    '#ff8','#ffa','#fff','#fff','#fff','#fff','#ffa','#ff8',
    '#ff8','#ffa','#fff','#fff','#fff','#fff','#ffa','#ff8',
    '#ff8','#ffa','#fff','#fff','#fff','#fff','#ffa','#ff8',
    '#ff8','#ffa','#ffa','#ffa','#ffa','#ffa','#ffa','#ff8',
    T,'#ff8','#ffa','#ffa','#ffa','#ffa','#ff8',T,
    T,T,'#ff8','#ff8','#ff8','#ff8',T,T,
  ]
}

// Area map pickup (8x8 parchment scroll)
export const MAP_SCROLL_SPRITE = {
  width: 8,
  height: 8,
  anchor: 'center',
  pixels: [
    T,T,'#5a3825','#5a3825','#5a3825','#5a3825',T,T,
    T,'#5a3825','#f4d58a','#f4d58a','#f4d58a','#f4d58a','#5a3825',T,
    '#5a3825','#f4d58a','#e8c777','#e8c777','#e8c777','#f4d58a','#f4d58a','#5a3825',
    '#5a3825','#f4d58a','#4d8f79','#e8c777','#4d8f79','#e8c777','#f4d58a','#5a3825',
    '#5a3825','#f4d58a','#e8c777','#4d8f79','#e8c777','#4d8f79','#f4d58a','#5a3825',
    '#5a3825','#f4d58a','#f4d58a','#f4d58a','#f4d58a','#f4d58a','#f4d58a','#5a3825',
    T,'#5a3825','#5a3825','#5a3825','#5a3825','#5a3825','#5a3825',T,
    T,T,T,T,T,T,T,T,
  ]
}

// Heart pickup sprite (16x16, transparent background)
export const HEART_SPRITE = {
  width: 16,
  height: 16,
  anchor: 'center',
  pixels: [
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,'#880011','#880011',T,T,'#880011','#880011',T,T,T,T,T,T,T,
    T,T,'#880011','#ff2244','#ff2244','#880011','#880011','#ff2244','#ff2244','#880011',T,T,T,T,T,T,
    T,'#880011','#ff4466','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#880011',T,T,T,T,T,
    T,'#880011','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#880011',T,T,T,T,T,
    T,'#880011','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#880011',T,T,T,T,T,
    T,T,'#880011','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#ff2244','#880011',T,T,T,T,T,T,
    T,T,T,'#880011','#ff2244','#ff2244','#ff2244','#ff2244','#880011',T,T,T,T,T,T,T,
    T,T,T,T,'#880011','#ff2244','#ff2244','#880011',T,T,T,T,T,T,T,T,
    T,T,T,T,T,'#880011','#880011',T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
  ]
}

const HEART_CROWN_PIXELS = new Map([
  ['3,0', '#f7da63'],
  ['6,0', '#fce78f'],
  ['9,0', '#f7da63'],
  ['3,1', '#8a5b12'],
  ['4,1', '#f7da63'],
  ['6,1', '#fce78f'],
  ['8,1', '#f7da63'],
  ['9,1', '#8a5b12'],
  ['3,2', '#8a5b12'],
  ['4,2', '#f7da63'],
  ['5,2', '#f7da63'],
  ['6,2', '#fce78f'],
  ['7,2', '#f7da63'],
  ['8,2', '#f7da63'],
  ['9,2', '#8a5b12'],
  ['3,3', '#8a5b12'],
  ['4,3', '#8a5b12'],
  ['5,3', '#8a5b12'],
  ['6,3', '#8a5b12'],
  ['7,3', '#8a5b12'],
  ['8,3', '#8a5b12'],
  ['9,3', '#8a5b12']
])

export const HEART_CONTAINER_SPRITE = {
  width: HEART_SPRITE.width,
  height: HEART_SPRITE.height,
  anchor: HEART_SPRITE.anchor,
  pixels: HEART_SPRITE.pixels.map((color, index) => {
    const x = index % HEART_SPRITE.width
    const y = Math.floor(index / HEART_SPRITE.width)
    return HEART_CROWN_PIXELS.get(`${x},${y}`) || color
  })
}

// World key sprite (16x16, transparent background)
export const KEY_SPRITE = {
  width: 16,
  height: 16,
  anchor: 'center',
  pixels: [
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,'#8a6a18','#8a6a18','#8a6a18','#8a6a18',T,T,T,T,T,T,T,
    T,T,T,T,'#8a6a18','#f7da63','#fce78f','#fce78f','#f7da63','#8a6a18',T,T,T,T,T,T,
    T,T,T,T,'#8a6a18','#fce78f',T,T,'#fce78f','#8a6a18',T,T,T,T,T,T,
    T,T,T,T,'#8a6a18','#f7da63','#fce78f','#fce78f','#f7da63','#8a6a18',T,T,T,T,T,T,
    T,T,T,T,T,'#8a6a18','#8a6a18','#8a6a18','#8a6a18',T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,'#f7da63','#f7da63','#f7da63','#f7da63',T,T,T,T,T,
    T,T,T,T,T,T,T,T,'#f7da63','#f7da63','#8a6a18',T,T,T,T,T,
    T,T,T,T,T,T,T,T,'#f7da63','#f7da63','#8a6a18','#f7da63',T,T,T,T,
    T,T,T,T,T,T,T,T,'#f7da63','#f7da63','#8a6a18','#f7da63',T,T,T,T,
    T,T,T,T,T,T,T,T,'#f7da63','#f7da63','#8a6a18','#f7da63','#f7da63',T,T,T,
    T,T,T,T,T,T,T,T,'#8a6a18','#8a6a18','#8a6a18','#8a6a18','#8a6a18',T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
  ]
}

// The final Purple Dooms key carries the Dark King's horned crest.
export const DARK_KING_KEY_SPRITE = {
  width: 16,
  height: 16,
  anchor: 'center',
  pixels: [
    T,T,'#d7a6ff','#d7a6ff',T,T,T,T,T,T,T,T,'#d7a6ff','#d7a6ff',T,T,
    T,'#d7a6ff','#8d45c7',T,T,T,T,T,T,T,T,T,T,'#8d45c7','#d7a6ff',T,
    T,'#8d45c7','#5b247f','#5b247f',T,T,T,T,T,T,T,T,'#5b247f','#5b247f','#8d45c7',T,
    T,T,'#5b247f','#8d45c7','#8d45c7','#8d45c7','#8d45c7','#8d45c7','#8d45c7','#8d45c7',T,T,T,T,T,T,
    T,T,T,'#5b247f','#b86be8','#d7a6ff','#d7a6ff','#b86be8','#8d45c7','#5b247f',T,T,T,T,T,T,
    T,T,T,'#5b247f','#b86be8',T,T,'#b86be8','#8d45c7','#5b247f',T,T,T,T,T,T,
    T,T,T,'#5b247f','#b86be8','#d7a6ff','#d7a6ff','#b86be8','#8d45c7','#5b247f',T,T,T,T,T,T,
    T,T,T,T,'#5b247f','#5b247f','#5b247f','#5b247f','#5b247f',T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,'#b86be8','#b86be8','#8d45c7',T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,'#b86be8','#8d45c7',T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,'#b86be8','#8d45c7','#b86be8',T,T,T,T,T,
    T,T,T,T,T,T,T,T,'#b86be8','#8d45c7','#b86be8','#b86be8',T,T,T,T,
    T,T,T,T,T,T,T,T,'#5b247f','#5b247f','#5b247f','#5b247f',T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
  ]
}

// Mapping enemy types to sprites (static fallback)
export const ENEMY_SPRITES = {
  zombie: ZOMBIE_SPRITE,
  skeleton: SKELETON_SPRITE,
  spider: SPIDER_SPRITE,
  orc: ORC_SPRITE,
  darkKnight: DARK_KNIGHT_SPRITE,
  shadowWolf: SHADOW_WOLF_SPRITE,
  darkWizard: DARK_WIZARD_SPRITE,
  emberGuard: EMBER_GUARD_SPRITE,
  cinderImp: CINDER_IMP_SPRITE,
  darkKing: DARK_KING_SPRITE
}

// Directional + walk sprites per enemy type
export const ENEMY_DIR_SPRITES = {
  zombie: ZOMBIE_SPRITES,
  skeleton: SKELETON_SPRITES,
}

export const ENEMY_WALK_SPRITES = {
  zombie: ZOMBIE_WALK_SPRITES,
  skeleton: SKELETON_WALK_SPRITES,
}

// Sword sprite (16x16, blade pointing right)
export const SWORD_SPRITE = {
  width: 16,
  height: 16,
  anchor: 'center',
  pixels: [
    T,T,T,T,T,T,T,T,T,T,T,T,T,'#6b1b38','#6b1b38',T,
    T,T,T,T,T,T,T,T,T,T,T,T,'#6b1b38','#bfefff','#bfefff','#6b1b38',
    T,T,T,T,T,T,T,T,T,T,T,'#6b1b38','#e8fdff','#e8fdff','#bfefff','#6b1b38',
    T,T,T,T,T,T,T,T,T,T,'#6b1b38','#e8fdff','#d5f8ff','#bfefff','#6b1b38',T,
    T,T,T,T,T,T,T,T,T,'#6b1b38','#e8fdff','#d5f8ff','#a8edff','#6b1b38',T,T,
    T,T,T,T,T,T,T,T,'#6b1b38','#d5f8ff','#bfefff','#8ddfff','#6b1b38',T,T,T,
    T,T,T,T,T,T,T,'#6b1b38','#bfefff','#a8edff','#7cd5ff','#6b1b38',T,T,T,T,
    T,T,T,T,T,T,'#6b1b38','#a8edff','#8ddfff','#5ec7ff','#6b1b38',T,T,T,T,T,
    T,T,T,T,T,'#6b1b38','#8ddfff','#7cd5ff','#4bbcff','#6b1b38',T,T,T,T,T,T,
    T,T,T,T,'#6b1b38','#7cd5ff','#5ec7ff','#3caff0','#6b1b38','#ffe169','#6b1b38','#6b1b38',T,T,T,T,
    T,T,T,'#6b1b38','#5ec7ff','#4bbcff','#3caff0','#2fa3e8','#6b1b38','#ffbf4d','#ffc95e','#6b1b38','#6b1b38',T,T,T,
    T,T,'#6b1b38','#4bbcff','#3caff0','#2fa3e8','#2fa3e8','#6b1b38','#ff9a5c','#ffbf4d','#9f5a12','#6b1b38',T,T,T,T,
    T,'#6b1b38','#3caff0','#2fa3e8','#2fa3e8','#6b1b38','#6b1b38','#ffbf4d','#ff9a5c','#9f5a12','#7a3f0e','#6b1b38',T,T,T,T,
    T,'#6b1b38','#2fa3e8','#2fa3e8','#6b1b38','#ffbf4d','#ff9a5c','#9f5a12','#9f5a12','#8a4d10','#6b1b38',T,T,T,T,T,
    T,T,'#6b1b38','#6b1b38','#ff9a5c','#ffbf4d','#9f5a12','#8a4d10','#7a3f0e','#6b1b38',T,T,T,T,T,T,
    T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,T,
  ]
}

const SWORD_BLADE_COLORS = Object.freeze({
  stone_sword: ['#d9d9d9', '#bcbcbc', '#a4a4a4', '#8b8b8b', '#737373', '#5f5f5f', '#4c4c4c', '#3d3d3d'],
  bone_sword: ['#fff1cc', '#f0ddb0', '#dfc997', '#cdb67e', '#baa367', '#a38d55', '#8c7747', '#76613a'],
  ember_sword: ['#fff079', '#ffd447', '#ffad32', '#ff8329', '#f15a24', '#ce3b22', '#aa2921', '#81201e'],
  legendary_sword: ['#f6c4ff', '#dfa0ef', '#ca7cde', '#b35dcc', '#9845b7', '#7e349d', '#652980', '#4d2065'],
  royal_sword: ['#fff8b8', '#ffe878', '#ffd34e', '#efb72d', '#d9951f', '#b87318', '#925514', '#6d3d10']
})

const BASE_SWORD_BLADE_COLORS = [
  '#e8fdff', '#d5f8ff', '#bfefff', '#a8edff',
  '#8ddfff', '#7cd5ff', '#5ec7ff', '#4bbcff',
  '#3caff0', '#2fa3e8'
]

const swordSpriteCache = new Map()

export function getSwordSprite(weaponId) {
  const materialColors = SWORD_BLADE_COLORS[weaponId]
  if (!materialColors) return SWORD_SPRITE
  if (swordSpriteCache.has(weaponId)) return swordSpriteCache.get(weaponId)

  const sprite = {
    ...SWORD_SPRITE,
    pixels: SWORD_SPRITE.pixels.map(color => {
      const colorIndex = BASE_SWORD_BLADE_COLORS.indexOf(color)
      if (colorIndex < 0) return color
      const materialIndex = Math.round(
        colorIndex * (materialColors.length - 1) / (BASE_SWORD_BLADE_COLORS.length - 1)
      )
      return materialColors[materialIndex]
    })
  }
  swordSpriteCache.set(weaponId, sprite)
  return sprite
}

// Item sprites for inventory (small 8x8 icons)
export const ITEM_SPRITES = {
  wood_sword: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,T,T,T,'#ccc','#fff',
      T,T,T,T,T,'#aaa','#ccc','#ccc',
      T,T,T,T,'#888','#aaa','#ccc',T,
      T,T,T,'#666','#888','#aaa',T,T,
      T,T,'#543','#666','#888',T,T,T,
      T,'#432','#543','#765',T,T,T,T,
      '#321','#432','#fb8',T,T,T,T,T,
      '#432',T,T,T,T,T,T,T,
    ]
  },
  stone_sword: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,T,T,T,'#999','#bbb',
      T,T,T,T,T,'#777','#999','#999',
      T,T,T,T,'#555','#777','#999',T,
      T,T,T,'#444','#555','#777',T,T,
      T,T,'#543','#444','#555',T,T,T,
      T,'#432','#543','#654',T,T,T,T,
      '#321','#432','#fb8',T,T,T,T,T,
      '#432',T,T,T,T,T,T,T,
    ]
  },
  iron_sword: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,T,T,T,'#ddd','#fff',
      T,T,T,T,T,'#bbb','#ddd','#ddd',
      T,T,T,T,'#999','#bbb','#ddd',T,
      T,T,T,'#777','#999','#bbb',T,T,
      T,T,'#654','#777','#999',T,T,T,
      T,'#543','#654','#876',T,T,T,T,
      '#432','#543','#fc8',T,T,T,T,T,
      '#543',T,T,T,T,T,T,T,
    ]
  },
  apple: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,'#3a2',T,T,T,T,
      T,T,'#c22','#5a3','#c22',T,T,T,
      T,'#e33','#f44','#f44','#f44','#e33',T,T,
      '#d22','#f44','#f66','#f66','#f44','#f44','#d22',T,
      '#c22','#f44','#f44','#f44','#f44','#f44','#c22',T,
      '#b11','#e33','#f44','#f44','#e33','#e33','#b11',T,
      T,'#a00','#d22','#d22','#d22','#a00',T,T,
      T,T,'#900','#900','#900',T,T,T,
    ]
  },
  stone: {
    width: 8,
    height: 8,
    pixels: [
      T,'#666','#777','#888','#888','#777','#666',T,
      '#666','#888','#999','#aaa','#999','#888','#777','#666',
      '#777','#999','#aaa','#aaa','#aaa','#999','#888','#777',
      '#888','#aaa','#aaa','#bbb','#aaa','#aaa','#999','#888',
      '#888','#999','#aaa','#aaa','#aaa','#999','#888','#888',
      '#777','#888','#999','#999','#999','#888','#777','#777',
      '#666','#777','#888','#888','#888','#777','#666','#666',
      T,'#555','#666','#777','#666','#555',T,T,
    ]
  },
  wood: {
    width: 8,
    height: 8,
    pixels: [
      T,'#543','#654','#765','#765','#654','#543',T,
      '#543','#654','#765','#876','#765','#654','#543','#432',
      '#654','#765','#876','#876','#876','#765','#654','#543',
      '#765','#876','#876','#987','#876','#876','#765','#654',
      '#765','#765','#876','#876','#876','#765','#654','#654',
      '#654','#654','#765','#765','#765','#654','#543','#543',
      '#543','#543','#654','#654','#654','#543','#432','#432',
      T,'#432','#543','#543','#543','#432',T,T,
    ]
  },
  brick: {
    width: 8,
    height: 8,
    pixels: [
      '#a44','#b55','#b55','#333','#c55','#c55','#b44','#a33',
      '#b55','#c66','#c66','#333','#d66','#d66','#c55','#b44',
      '#333','#333','#333','#333','#333','#333','#333','#333',
      '#c55','#d66','#333','#b55','#c66','#c66','#333','#a44',
      '#c55','#d66','#333','#b55','#c66','#c66','#333','#a44',
      '#333','#333','#333','#333','#333','#333','#333','#333',
      '#b44','#c55','#c55','#333','#b55','#b55','#a44','#933',
      '#a33','#b44','#b44','#333','#a44','#a44','#933','#822',
    ]
  },
  planks: {
    width: 8,
    height: 8,
    pixels: [
      '#b97','#ca8','#ca8','#432','#ca8','#ca8','#b97','#a86',
      '#ca8','#dba','#dba','#432','#dba','#dba','#ca8','#b97',
      '#ca8','#dba','#dba','#432','#dba','#dba','#ca8','#b97',
      '#432','#432','#432','#432','#432','#432','#432','#432',
      '#ca8','#dba','#432','#ca8','#dba','#dba','#432','#b97',
      '#ca8','#dba','#432','#ca8','#dba','#dba','#432','#b97',
      '#432','#432','#432','#432','#432','#432','#432','#432',
      '#a86','#b97','#b97','#432','#b97','#b97','#a86','#975',
    ]
  },
  diamond_sword: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,T,T,T,'#5df','#8ff',
      T,T,T,T,T,'#3bf','#5df','#5df',
      T,T,T,T,'#19d','#3bf','#5df',T,
      T,T,T,'#07b','#19d','#3bf',T,T,
      T,T,'#654','#07b','#19d',T,T,T,
      T,'#543','#654','#876',T,T,T,T,
      '#432','#543','#fc8',T,T,T,T,T,
      '#543',T,T,T,T,T,T,T,
    ]
  },
  legendary_sword: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,T,T,T,'#ff0','#ff8',
      T,T,T,T,T,'#fc0','#ff0','#ff0',
      T,T,T,T,'#f90','#fc0','#ff0',T,
      T,T,T,'#f60','#f90','#fc0',T,T,
      T,T,'#654','#f60','#f90',T,T,T,
      T,'#543','#654','#a86',T,T,T,T,
      '#432','#543','#fc8',T,T,T,T,T,
      '#543',T,T,T,T,T,T,T,
    ]
  },
  bread: {
    width: 8,
    height: 8,
    pixels: [
      T,T,'#c95','#da6','#da6','#c95',T,T,
      T,'#b84','#da6','#eb7','#eb7','#da6','#c95',T,
      '#a73','#c95','#eb7','#fc8','#fc8','#eb7','#da6','#b84',
      '#a73','#da6','#fc8','#fc8','#fc8','#fc8','#eb7','#c95',
      '#962','#c95','#eb7','#fc8','#fc8','#eb7','#da6','#b84',
      T,'#a73','#c95','#da6','#da6','#c95','#b84',T,
      T,T,'#962','#a73','#a73','#962',T,T,
      T,T,T,T,T,T,T,T,
    ]
  },
  cooked_meat: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,'#a52','#a52',T,T,T,
      T,T,'#a52','#c63','#c63','#a52',T,T,
      T,'#832','#c63','#e85','#e85','#c63','#832',T,
      '#621','#a52','#e85','#fa6','#fa6','#e85','#a52','#621',
      '#621','#a52','#e85','#fa6','#fa6','#e85','#a52','#621',
      T,'#832','#c63','#e85','#e85','#c63','#832',T,
      T,T,'#a52','#c63','#c63','#a52',T,T,
      T,T,T,'#832','#832',T,T,T,
    ]
  },
  steak: {
    width: 8,
    height: 8,
    pixels: [
      T,'#722','#833','#944','#944','#833',T,T,
      '#611','#833','#a55','#b66','#b66','#a55','#833',T,
      '#722','#a55','#c77','#d88','#d88','#c77','#a55','#722',
      '#833','#b66','#d88','#e99','#e99','#d88','#b66','#833',
      '#833','#a55','#c77','#d88','#d88','#c77','#a55','#833',
      '#722','#944','#b66','#c77','#c77','#b66','#944','#722',
      T,'#833','#944','#a55','#a55','#944','#833',T,
      T,T,'#722','#833','#833','#722',T,T,
    ]
  },
  golden_apple: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,'#5a3',T,T,T,T,
      T,T,'#fc0','#7b4','#fc0',T,T,T,
      T,'#fb0','#fd2','#fd2','#fd2','#fb0',T,T,
      '#fa0','#fd2','#fe4','#fe4','#fd2','#fd2','#fa0',T,
      '#fa0','#fd2','#fd2','#fd2','#fd2','#fd2','#fa0',T,
      '#f90','#fb0','#fd2','#fd2','#fb0','#fb0','#f90',T,
      T,'#e80','#fa0','#fa0','#fa0','#e80',T,T,
      T,T,'#d70','#d70','#d70',T,T,T,
    ]
  },
  rotten_flesh: {
    width: 8,
    height: 8,
    pixels: [
      T,'#352','#463','#574',T,T,T,T,
      '#241','#463','#574','#685','#574','#463',T,T,
      '#352','#574','#685','#796','#685','#574','#352',T,
      '#463','#685','#796','#685','#796','#685','#463','#241',
      '#463','#574','#685','#796','#685','#574','#463','#352',
      '#352','#463','#574','#685','#574','#463','#352',T,
      T,'#352','#463','#574','#463','#352',T,T,
      T,T,'#241','#352','#241',T,T,T,
    ]
  },
  health_potion: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,'#888','#888',T,T,T,
      T,T,'#aaa','#bbb','#bbb','#aaa',T,T,
      T,T,'#f33','#f55','#f55','#f33',T,T,
      T,'#d11','#f33','#f77','#f77','#f33','#d11',T,
      T,'#d11','#f44','#f88','#f88','#f44','#d11',T,
      T,'#c00','#f33','#f66','#f66','#f33','#c00',T,
      T,T,'#b00','#e22','#e22','#b00',T,T,
      T,T,T,'#900','#900',T,T,T,
    ]
  },
  leather_armor: {
    width: 8,
    height: 8,
    pixels: [
      T,'#864','#964','#a75','#a75','#964','#864',T,
      '#753','#964','#a75','#b86','#b86','#a75','#964','#753',
      '#864','#a75','#b86','#c97','#c97','#b86','#a75','#864',
      T,'#964','#a75','#b86','#b86','#a75','#964',T,
      T,'#864','#964','#a75','#a75','#964','#864',T,
      T,'#753','#864','#964','#964','#864','#753',T,
      T,T,'#753','#864','#864','#753',T,T,
      T,T,T,T,T,T,T,T,
    ]
  },
  iron_armor: {
    width: 8,
    height: 8,
    pixels: [
      T,'#999','#aaa','#bbb','#bbb','#aaa','#999',T,
      '#888','#aaa','#bbb','#ccc','#ccc','#bbb','#aaa','#888',
      '#999','#bbb','#ccc','#ddd','#ddd','#ccc','#bbb','#999',
      T,'#aaa','#bbb','#ccc','#ccc','#bbb','#aaa',T,
      T,'#999','#aaa','#bbb','#bbb','#aaa','#999',T,
      T,'#888','#999','#aaa','#aaa','#999','#888',T,
      T,T,'#888','#999','#999','#888',T,T,
      T,T,T,T,T,T,T,T,
    ]
  },
  diamond_armor: {
    width: 8,
    height: 8,
    pixels: [
      T,'#5cf','#6df','#7ef','#7ef','#6df','#5cf',T,
      '#4bf','#6df','#7ef','#9ff','#9ff','#7ef','#6df','#4bf',
      '#5cf','#7ef','#9ff','#aff','#aff','#9ff','#7ef','#5cf',
      T,'#6df','#7ef','#9ff','#9ff','#7ef','#6df',T,
      T,'#5cf','#6df','#7ef','#7ef','#6df','#5cf',T,
      T,'#4bf','#5cf','#6df','#6df','#5cf','#4bf',T,
      T,T,'#4bf','#5cf','#5cf','#4bf',T,T,
      T,T,T,T,T,T,T,T,
    ]
  },
  torch: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,'#ff8','#ff0',T,T,T,
      T,T,'#fa0','#fc4','#fc4','#f80',T,T,
      T,T,T,'#f60','#f60',T,T,T,
      T,T,T,'#654','#654',T,T,T,
      T,T,T,'#543','#543',T,T,T,
      T,T,T,'#543','#543',T,T,T,
      T,T,T,'#432','#432',T,T,T,
      T,T,T,'#321','#321',T,T,T,
    ]
  },
  bone: {
    width: 8,
    height: 8,
    pixels: [
      '#ddd','#eee',T,T,T,T,'#eee','#ddd',
      '#eee','#fff','#ddd',T,T,'#ddd','#fff','#eee',
      T,'#ddd','#eee','#ddd','#ddd','#eee','#ddd',T,
      T,T,'#ddd','#eee','#eee','#ddd',T,T,
      T,T,'#ddd','#eee','#eee','#ddd',T,T,
      T,'#ddd','#eee','#ddd','#ddd','#eee','#ddd',T,
      '#eee','#fff','#ddd',T,T,'#ddd','#fff','#eee',
      '#ddd','#eee',T,T,T,T,'#eee','#ddd',
    ]
  },
  string: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,T,T,'#ddd','#eee',T,
      T,T,T,T,'#ccc','#ddd',T,T,
      T,T,T,'#bbb','#ccc',T,T,T,
      T,T,'#aaa','#bbb',T,T,T,T,
      T,'#999','#aaa',T,T,T,T,T,
      '#888','#999',T,T,T,T,T,T,
      '#999',T,T,T,T,T,T,T,
      T,T,T,T,T,T,T,T,
    ]
  },
  spider_eye: {
    width: 8,
    height: 8,
    pixels: [
      T,T,'#400','#500','#500','#400',T,T,
      T,'#400','#600','#800','#800','#600','#400',T,
      '#400','#600','#a00','#f00','#f00','#a00','#600','#400',
      '#500','#800','#f00','#fff','#fff','#f00','#800','#500',
      '#500','#800','#f00','#fff','#fff','#f00','#800','#500',
      '#400','#600','#a00','#f00','#f00','#a00','#600','#400',
      T,'#400','#600','#800','#800','#600','#400',T,
      T,T,'#400','#500','#500','#400',T,T,
    ]
  },
  wolf_pelt: {
    width: 8,
    height: 8,
    pixels: [
      '#444','#555',T,T,T,T,'#555','#444',
      '#555','#666','#555','#444','#444','#555','#666','#555',
      T,'#555','#666','#777','#777','#666','#555',T,
      T,'#444','#666','#888','#888','#666','#444',T,
      T,'#444','#666','#888','#888','#666','#444',T,
      T,'#555','#666','#777','#777','#666','#555',T,
      '#555','#666','#555','#444','#444','#555','#666','#555',
      '#444','#555',T,T,T,T,'#555','#444',
    ]
  },
  magic_crystal: {
    width: 8,
    height: 8,
    pixels: [
      T,T,T,'#a0f','#a0f',T,T,T,
      T,T,'#80c','#c0f','#c0f','#80c',T,T,
      T,'#60a','#a0f','#e0f','#e0f','#a0f','#60a',T,
      '#408','#80c','#c0f','#f0f','#f0f','#c0f','#80c','#408',
      '#408','#80c','#c0f','#f0f','#f0f','#c0f','#80c','#408',
      T,'#60a','#a0f','#e0f','#e0f','#a0f','#60a',T,
      T,T,'#80c','#c0f','#c0f','#80c',T,T,
      T,T,T,'#a0f','#a0f',T,T,T,
    ]
  },
  cobblestone: {
    width: 8,
    height: 8,
    pixels: [
      '#777','#888','#666','#888','#999','#777','#666','#888',
      '#888','#999','#777','#999','#888','#666','#777','#999',
      '#666','#777','#999','#888','#777','#888','#999','#777',
      '#888','#999','#666','#777','#999','#666','#888','#666',
      '#999','#777','#888','#999','#666','#777','#666','#888',
      '#666','#888','#999','#777','#888','#999','#777','#999',
      '#777','#666','#777','#888','#999','#666','#888','#777',
      '#888','#999','#666','#999','#777','#888','#999','#666',
    ]
  }
}

// Helper to render a sprite to a canvas
export function renderSpriteToCanvas(sprite, scale = 1) {
  const canvas = document.createElement('canvas')
  canvas.width = sprite.width * scale
  canvas.height = sprite.height * scale
  const ctx = canvas.getContext('2d')
  ctx.imageSmoothingEnabled = false
  
  for (let y = 0; y < sprite.height; y++) {
    for (let x = 0; x < sprite.width; x++) {
      const color = sprite.pixels[y * sprite.width + x]
      if (color && color !== 'transparent') {
        ctx.fillStyle = color
        ctx.fillRect(x * scale, y * scale, scale, scale)
      }
    }
  }
  return canvas
}

// Get item sprite by item id
export function getItemSprite(itemId) {
  return ITEM_SPRITES[itemId] || null
}
